//@ts-ignore
// @ts-nocheck
import { types, applySnapshot } from "mobx-state-tree";

export const TeacherSelectStore = types
  .model("TeacherSelectStore", {
    teacherOption: types.optional(types.string, ""),
    teacherGender: types.optional(types.string, "anyone"),
  })
  .actions((self) => {
    return {
      updateField(data) {
        applySnapshot(self, data);
      },
      getSplitRequest(teacherSplitOptions) {
        if (self.teacherOption) {
          return teacherSplitOptions[self.teacherOption];
        }
        return [];
      },
    };
  });

export default TeacherSelectStore;
